import { FC } from 'react';

type Props = {
  /** Линии в пикселях от левого края сетки */
  lines: number[];
};

/**
 * Линии сетки дашборда, на которые может встать граница растягиваемой диаграммы: видно, на какую из
 * них граница встанет. Показаны только на время растягивания по ширине.
 */
export const ChartGridLines: FC<Props> = ({ lines }) => (
  <>
    {lines.map((left) => (
      <div
        key={left}
        aria-hidden
        className="pointer-events-none absolute inset-y-0 z-20 w-0 border-l border-dashed border-primary/60"
        style={{ left }}
      />
    ))}
  </>
);
